import { Children, JSX, ReactNode } from "react";
import { BaseComponent } from "../../Core/BaseComponent/BaseComponent";
import React from "react";
import {GridContainer} from "../Grid/GridContainer";
import {GridItem, IGridItemProps as IGridProps } from "../Grid/GridItem";

export class Box extends BaseComponent<IBoxProps, IBoxState>
{
    private gridItemRef = React.createRef<GridItem>();
    private nullRef: React.RefObject<null> = { current: null };
    public get ref(): React.RefObject<HTMLDivElement | null> { return this.gridItemRef.current?.ref ?? this.nullRef; }

    public render(): JSX.Element
    {
        const { children, ...gridProps } = this.props;
        return (
            <GridContainer>
                <GridItem
                    compact={12}
                    {...gridProps}
                    ref={this.gridItemRef}
                >
                    {this.props.children}
                </GridItem>
            </GridContainer>
        );
    }
}

export interface IBoxProps extends IGridProps { } // todo: omit xs, etc?
export interface IBoxState { }
